<template>
  <v-dialog v-model="isPromptVisible" persistent max-width="600px">

    <v-card v-if="displayMode === 'loader'">
      <div class="progressWrapper">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
      </div>
    </v-card>

    <v-card v-if="displayMode === 'success'">
      <div class="progressWrapper">
        <img src="../../../../assets/images/check-mark-verified.gif" alt="" />
        <h3>{{ successMessage }}</h3>
      </div>
    </v-card>

    <v-card v-if="displayMode === 'form'">

      <v-card-title>
        <span class="headline">Create SMS Schedule</span>
      </v-card-title>

      <v-card-text>
        <v-container>

          <v-row>
            <v-col cols="12">
              <div v-if="!onlySchedule" class="bulktabSwitcher">
                <div class="tabSwitcherInnerWRapper">
                  <div :class="selectedGroupType === 'static' ? 'tab selected' : 'tab'"
                    @click="_selectGroupType('static')">
                    Static Groups
                  </div>
                  <div :class="selectedGroupType === 'dynamic' ? 'tab selected' : 'tab'"
                    @click="_selectGroupType('dynamic')">
                    Dynamic Groups
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-autocomplete v-model="selectedGroupId"
                :items="selectedGroupType === 'static' ? staticGroups : dynamicGroups" :label="selectedGroupType === 'static'
                    ? 'Select Static Group *'
                    : 'Select Dynamic Group *'
                  " item-text="Name" item-value="GroupID" required :error="!selectedGroupId && isFormDirty" />
            </v-col>
          </v-row>

          <v-row>
            <div class="placeHoldersWrapper">
              <div class="templateTypeSelectorOuterWrapper">
                <div class="templateTypeSelectorInnerWrapper">
                  <div :class="selectedTemplateType === 'userTemplates' ? 'tab selected' : 'tab'"
                    @click="_selectTemplateType('userTemplates')">
                    Practice Templates
                  </div>
                  <div :class="selectedTemplateType === 'systemTemplates' ? 'tab selected' : 'tab'"
                    @click="_selectTemplateType('systemTemplates')">
                    System Templates
                  </div>
                </div>
              </div>
              <div class="label">Select a template to use:</div>
              <v-autocomplete v-model="selectedTemplateId" class="filterSelector"
                :items="selectableTemplates" label="Select Template"
                item-text="name" item-value="templateID" />
            </div>
          </v-row>

        </v-container>

        <message-scheduler :shouldSchedule.sync="shouldSchedule" :selectedFrequency.sync="selectedFrequency"
          :startDate.sync="startDate" :time.sync="time" :endDate.sync="endDate" :showToggleButton="!onlySchedule" />

      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="close"> Cancel </v-btn>
        <v-btn color="primary" text @click="schedule">
          Schedule
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import moment from "moment";
  import { ApiCalls } from "../../../../api-calls";
  import UserHelper from "../../../../utils/user-helper";
  import EventEmitter from "../../../../utils/event-emitter";
  import MessageScheduler from "../../../shared-module/common-components/message-scheduler/message-scheduler.vue";
  import Api from "../../../shared-module/api";
  import HelperMethods from "../../../../utils/helper-methods";
  import { mapState } from 'vuex';

  export default {
    name: "GroupBulkSmsComposer",
    components: {
      MessageTestNumberInput: () => import("../message-test-number-input/message-test-number-input.vue"),
      MessageScheduler
    },
    props: {
      patients: {
        type: Array,
        default: null,
      },
    },
    data: () => ({
      isPromptVisible: false,
      field: {
        name: "",
        message: "",
        mediaUrl: "",
        testNumber: "",
        signature: ""
      },
      twilioSid: "ACfffb0bc0e31d44d40c9ecf9e6647c69d",
      practiceID: "",
      maxMessageLength: 200,
      snackbar: false,
      startDate: "",
      endDate: "",
      time: "",
      isEditing: false,
      editId: null,
      notification: "Unknown",
      file: null,
      isTestInputPromptVisible: false,
      messageTemplates: [],
      shouldSchedule: true,
      selectedTemplateMediaUrl: "",
      templates: [],
      selectedPatients: [],
      staticGroups: [],
      successMessage: "",
      dynamicGroups: [],
      onlySchedule: false,
      selectedGroupType: "static", // Another value 'dynamic'
      selectedGroupId: null,
      isLoading: true,
      displayMode: "loader", // Other values 'form', 'success'
      selectedTemplateId: null,
      selectedTemplate: null,
      isContentDisabled: false,
      selectedTemplateType: "userTemplates",
      selectableTemplates: [],
      selectedTemplate: null,
      maxAllowedChars: 140,
      selectedFrequency: 0,
      selectedPracticeId: null,
      allFrequencies: [
        {
          label: "Select One",
          value: 0
        },
        {
          label: "Daily",
          value: 2
        },
        {
          label: "Weekly",
          value: 3
        },
        {
          label: "Monthly",
          value: 4
        },
        {
          label: "Yearly",
          value: 5
        }
      ],
      isFormDirty: false
    }),

    computed: {
      activePractice() {
        console.log('Group Bulk SMS Composer computed' + this.$store.state.posActivePractice.value);
        return this.$store.state.posActivePractice.value;
      }
    },

    watch: {
      selectedTemplateId(val) {
        if (val > 0) {
          const template = this.selectableTemplates.find(t => t.templateID === val);
          // console.log("template :>> ", template);
          if (template) {
            this.selectedTemplate = template;
            this.field.message = template.templateBody ? template.templateBody : "";
            this.isContentDisabled = false;
            if (template.flowID && template.flowID.length) {
              this.isContentDisabled = true;
            }
            if (template.mediaURL && template.mediaURL.length) {
              this.selectedTemplateMediaUrl = template.mediaURL;
            } else {
              this.selectedTemplateMediaUrl = "";
            }
            console.log("this.field :>> ", this.field);
            return;
          }
        }
        this.selectedTemplateMediaUrl = "";
        this.isContentDisabled = false;
        this.selectedTemplate = null;
        this.field.message = "";
      },
      '$store.state.posActivePractice': function () {
        this._loadMetadata();
      },
      selectedTemplateType(val) {
        this._onTemplateTypeUpdate(val);
      },
      selectedPatients() {
        this.selectedPatients = this.$props.patients;
      }
    },
    created() {

      this._loadMetadata();

      EventEmitter.subscribe("show-group-bulk-sms-composer", async payload => {

        this.isPromptVisible = true;
        this.selectedGroupType = "static";

        this.onlySchedule = false;
        this.shouldSchedule = true;

        if (payload) {

          //set values
          this.isEditing = payload.isEditing === true ? payload.isEditing : false;
          this.selectedPracticeId = payload.practiceId && payload.practiceId.length ? payload.practiceId : null;

          await this._loadMetadata({ practiceId: payload.practiceId });

          if (payload.selectedGroupType && payload.selectedGroupType.length) {
            this.selectedGroupType = payload.selectedGroupType;
          }

          if (payload.selectedGroup) {
            this.selectedGroupId = payload.selectedGroup.GroupID;
          }

          if (payload.selectedTemplate) {

            this.selectedTemplate = payload.selectedTemplate;

            if (payload.selectedTemplate.isSystemTemplate) {

              this.selectedTemplateType = "systemTemplates";

            } else {

              this.selectedTemplateType = "userTemplates";

            }
            setTimeout(() => {
              this.selectedTemplateId = payload.selectedTemplate.templateID;
            }, 100);
          }
          if (this.isEditing) {
            this._assignItemFields(payload.item);
          }
        } else {
          this._loadMetadata();
        }
      });
      EventEmitter.subscribe("hide-group-bulk-sms-composer", () => {
        this.isPromptVisible = false;
      });
    },

    methods: {

      mounted() {
        console.log('Patients: ' + this.$props.patients);
      },
      _onTemplateTypeUpdate(val) {
        this.selectedTemplateId = null;
        this.selectedTemplate = null;
        this.isContentDisabled = false;
        this.selectedTemplate = null;
        this.selectedTemplateMediaUrl = "";
        this.field.message = "";
        this.field.signature = "";
        if (val === "userTemplates") {
          this.selectableTemplates = this.userTemplates;
        } else {
          // System templates
          this.selectableTemplates = this.systemTemplates;
        }
      },

      _assignItemFields(item) {
        this.field.name = item.CampaignName || '';
        if (item.Message) {
          this.field.message = item.Message || '';
        }
        this.editId = item.ID;
        this.field.signature = item.Signiture || '';
        this.selectedGroupId = item.GroupID;
        this.selectedGroupType = item.GroupTypeID === 1 ? 'static' : 'dynamic';
        this.selectedTemplateId = item.TemplateID;
        this.selectedTemplate = this.selectableTemplates.find(t => t.templateID === item.TemplateID);
        this.selectedTemplateMediaUrl = item.MediaURL || '';
        this.startDate = item.StartDate ? moment(item.StartDate).format('YYYY-MM-DD') : '';
        this.endDate = item.EndDate ? moment(item.EndDate).format('YYYY-MM-DD') : '';
        this.time = item.StartDate ? moment(item.StartDate).format('hh:mm a') : '';
        this.shouldSchedule = true;
        this.selectedFrequency = item.Recurring || 0;
        this.isContentDisabled = false;
        if (this.selectedTemplate && this.selectedTemplate.flowID && this.selectedTemplate.flowID.length) {
          this.isContentDisabled = true;
        }
      },
      _getPracticeIdFromStore() {
        let practiceId = this.$store.state.posActivePractice != null ? this.$store.state.posActivePractice.value : this.selectedPracticeId;

        if (!practiceId && !practiceId.length) {
          this.notification = "Unable to get activePracticeId from the store.";
          this.snackbar = true;
        }

        return practiceId;
      },

      async _loadMetadata({ practiceId = null } = {}) {

        let finalPracticeId = this.$store.state.posActivePractice != null ? this.$store.state.posActivePractice.value : this.selectedPracticeId;

        if (practiceId) {
          finalPracticeId = practiceId;
          console.log(finalPracticeId);
        }

        try {
          
          this.selectedPatients = this.$props.patients;

          console.log(this.selectedPatients);

          await Promise.allSettled([
            this._fetchStaticGroups(finalPracticeId),
            this._fetchDynamicGroups(finalPracticeId),
            this._fetchPracticeTemplates(finalPracticeId),
            this._fetchSystemTemplates(finalPracticeId)
          ]);
          this.displayMode = "form";
          this._generateSelectableTemplates();
        } catch (error) {
          console.log("error :>> ", error);
          setTimeout(() => {
            this.isPromptVisible = false;
          }, 1000);
        }
      },
      _generateSelectableTemplates() {
        if (this.selectedTemplateType === "userTemplates") {
          this.selectableTemplates = this.userTemplates;
        } else {
          this.selectableTemplates = this.systemTemplates;
        }
      },
      async _fetchStaticGroups(practiceID = null) {
        try {
          const { data } = await ApiCalls.fetchGroups(practiceID || this.$store.state.posActivePractice.value);
          this.staticGroups = data;
        } catch (error) {
          console.log("error", error);
        }
      },
      async _fetchDynamicGroups(practiceId) {
        let dynamicGroups = [];
        try {
          if (practiceId) {
            const { data } = await Api.practiceGroup.private.fetch(practiceId);
            dynamicGroups = data;
          } else {
            const { data } = await ApiCalls.fetchDynamicGroups(this.$store.state.posActivePractice.value);
            dynamicGroups = data;
          }
        } catch (error) {
          console.log("error", error);
        }
        this.dynamicGroups = dynamicGroups;
      },

      async _fetchPracticeTemplates(practiceId = null) {
        let practiceTemplates = [];
        try {
          const { data } = await Api.template.private.fetchPracticeTemplates({
            templateCategoryId: this.onlySchedule ? 0 : 3,
            practiceId: practiceId || this.$store.state.posActivePractice.value
          });
          practiceTemplates = data;
        } catch (error) {
          console.log("error", error);
        }
        // console.log('practiceTemplates 123333:>> ', practiceTemplates);
        this.userTemplates = this._filterTemplates(practiceTemplates);
      },
      async _fetchSystemTemplates(practiceID = null) {
        let systemTemplates = [];
        try {
          const { data } = await Api.template.private.fetchSystemTemplates({
            templateCategoryId: this.onlySchedule ? 0 : 3,
            templateTypeId: 1
          });
          systemTemplates = data;
        } catch (error) {
          console.log("error", error);
        }
        // console.log('systemTemplates 123333:>> ', systemTemplates);
        this.systemTemplates = this._filterTemplates(systemTemplates);
      },
      _selectTemplateType(templateType) {
        this.selectedTemplateType = templateType;
      },
      _selectGroupType(groupType) {
        this.selectedGroupType = groupType;
        this.selectedGroupId = null;
      },
      _filterTemplates(templates = []) {
        let filteredTemplates = templates.filter(t => t.templateTypeID === 1);
        if (!this.onlySchedule) {
          filteredTemplates = filteredTemplates.filter(
            template => template.templateCategoryID !== 2 && template.templateCategoryID !== 1
          );
        }
        return filteredTemplates;
      },
      replaceBody(template) {
        if (template.mediaURL && template.mediaURL.length) {
          this.selectedTemplateMediaUrl = template.mediaURL;
        } else {
          this.selectedTemplateMediaUrl = "";
        }
        this.field.message = template.templateBody;
      },
      _prependAreaCodeIfRequired(phoneNumber) {
        if (phoneNumber && phoneNumber.length) {
          if (phoneNumber.indexOf("+1") === 0) {
            return phoneNumber;
          } else {
            return `+1${phoneNumber}`;
          }
        }
        return null;
      },

      _reset() {
        this.field = {
          name: "",
          message: "",
          mediaUrl: "",
          testNumber: "",
          signature: ""
        };
        this.selectedGroupId = null;
        this.selectedGroupType = "static";
        this.selectedTemplateMediaUrl = "";
        this.startDate = "";
        this.endDate = "";
        this.time = "";
        this.shouldSchedule = false;
        this.onlySchedule = false;
        this.file = null;
        this.selectedTemplate = null;
        this.selectedTemplateId = null;
        this.isContentDisabled = false;
        this.selectedFrequency = 0;
      },

      _showSuccessMessage(successMessage) {
        this.successMessage = successMessage;
        this.displayMode = "success";
        setTimeout(() => {
          this._reset();
          this.isPromptVisible = false;
        }, 2500);
      },

      showTestInputPrompt() {
        if (!this.selectedGroupId) {
          // this.notification = "Please add a message or select a file to send";
          this.notification = "Please select a group";
          this.snackbar = true;
          return;
        }
        if (!this.field.message.length) {
          // this.notification = "Please add a message or select a file to send";
          this.notification = "Please add a message";
          this.snackbar = true;
          return;
        }
        if (!HelperMethods.validateMessagePlaceholders(this.field.message)) {
          this.snackbar = true;
          this.notification = "First name and Last name in the same message violates HIPAA laws";
          return;
        }
        this.isTestInputPromptVisible = true;
      },

      async schedule() {

        if (!this.selectedGroupId) {
          this.notification = "A Group is required to create a Schedule";
          this.snackbar = true;
          return;
        }

        if (!this.selectedTemplate) {
          this.notification = "A Template is required to create a Schedule";
          this.snackbar = true;
          return;
        }

        // Check if date and time are valid
        if (!(this.startDate && this.startDate.length)) {
          this.notification = "Please provide a valid date";
          this.snackbar = true;
          return;
        }
        if (!this.time) {
          this.notification = "Please provide a valid time";
          this.snackbar = true;
          return;
        }
        const datePart = this.startDate.split("T")[0];
        const dateTime = moment(`${datePart} ${this.time}`);
        let endDateTime = null;
        if (this.endDate) {
          const endDatePart = this.endDate.split("T")[0];
          endDateTime = moment(`${endDatePart} ${this.time}`);
        }
        if (!dateTime.isValid()) {
          this.notification = "Please select a valid time";
          this.snackbar = true;
          return;
        }
        
        if (!this.field.message.length) {
          // this.notification = "Please add a message or select a file to send";
          this.notification = "Please add a message";
          this.snackbar = true;
          return;
        }
        if (!HelperMethods.validateMessagePlaceholders(this.field.message)) {
          this.snackbar = true;
          this.notification = "First name and Last name in the same message violates HIPAA laws";
          return;
        }
        this.displayMode = "loader";
        let mediaUrl = "";
        if (this.file) {
          mediaUrl = await this.uploadFile();
        } else if (this.selectedTemplateMediaUrl && this.selectedTemplateMediaUrl.length) {
          mediaUrl = this.selectedTemplateMediaUrl;
        }
        if (this._isFlowExecutionRequired()) {
          // With flow id
          this._scheduleWithFlowId({
            dateTime,
            endDateTime
          });
        } else {
          // No flow id
          // const activeClinic = UserHelper.getActiveClinic();
          let activePracticeId = this._getPracticeIdFromStore();
          let campaignName = this.field.name;
          if (!(campaignName && campaignName.length)) {
            campaignName = `${activePracticeId}-${+new Date()}`;
          }
          const messagePayload = {
            Message: this.selectedTemplate != null ? this.selectedTemplate.content : null,
            CampaignName: this.selectedTemplate ? this.selectedTemplate.name : '',
            PracticeID: activePracticeId,
            GroupID: this.selectedGroupId,
            TemplateID: this.selectedTemplate != null ? this.selectedTemplate.templateID : null,
            TemplateName: this.selectedTemplate != null ? this.selectedTemplate.name : '',
            SendDate: new Date().toLocaleString()
          };
          if (endDateTime) {
            messagePayload.EndDate = endDateTime;
          }
          if (this.selectedPracticeId) {
            messagePayload.practiceId = this.selectedPracticeId;
          }
          if (this.selectedFrequency > 0) {
            messagePayload.Recurring = this.selectedFrequency;
          }
          if (mediaUrl && mediaUrl.length) {
            messagePayload.MediaURL = mediaUrl;
          }
          messagePayload.MessageCategoryTypeID = 3;
          if (this.selectedGroupType === "static") {
            messagePayload.GroupTypeID = "1";
          } else {
            const selectedDynamicGroup = this.dynamicGroups.find(
              g => g.GroupID === this.selectedGroupId
            );
            if (selectedDynamicGroup) {
              messagePayload.MessageCategoryTypeID = selectedDynamicGroup.GroupFilterTypeID;
              messagePayload.GroupTypeID = "2";
              messagePayload.GroupFilterTypeID = selectedDynamicGroup.GroupFilterTypeID;
              messagePayload.GroupFilterTypeData1 = selectedDynamicGroup.FilterData1;
              if (selectedDynamicGroup.FilterData2) {
                messagePayload.GroupFilterTypeData2 = selectedDynamicGroup.FilterData2;
              }
            }
          }
          try {
            if (this.isEditing) {
              // Remove all null values
              Object.keys(messagePayload).forEach(key => {
                if (messagePayload[key] === null) {
                  delete messagePayload[key];
                }
              });
              await Api.sms.private.editScheduledMessage(messagePayload, this.editId).then(x => {
                this.$forceUpdate();
              });
              // await ApiCalls.updateScheduledMessage(messagePayload, this.editId);
            } else {
              await ApiCalls.createSchedule(messagePayload);
            }
            // Success
            this._showSuccessMessage("Message scheduled successfully");
            EventEmitter.dispatch("message-scheduled");
          } catch (error) {
            this.displayMode = "form";
            this.notification = "Unable to schedule message";
            this.snackbar = true;
          }
        }
      },

      async _scheduleWithFlowId({ dateTime, endDateTime }) {
        const messagePayload = {
          StartDate: dateTime,
          FlowID: this.selectedTemplate.flowID,
          ToPhoneNumbers: "",
          GroupID: this.selectedGroupId,
          FlowPhoneNumber: "+17088872527",
          Message: this.field.message,
          SendDate: new Date().toLocaleString()
        };
        if (endDateTime) {
          messagePayload.EndDate = endDateTime;
        }
        if (this.selectedPracticeId) {
          messagePayload.practiceId = this.selectedPracticeId;
        }
        if (this.selectedFrequency > 0) {
          messagePayload.Recurring = this.selectedFrequency;
        }
        // if (this.selectedTemplate.templateCategoryID === 3) {
        //   messagePayload.Message = this.field.message;
        // }
        if (this.selectedTemplate) {
          messagePayload.MessageCategoryTypeID = this.selectedTemplate.templateCategoryID;
        } else {
          messagePayload.MessageCategoryTypeID = 3;
        }
        if (this.selectedGroupType === "static") {
          messagePayload.GroupTypeID = "1";
          messagePayload.MessageCategoryTypeID = 3;
        } else {
          const selectedDynamicGroup = this.dynamicGroups.find(
            g => g.GroupID === this.selectedGroupId
          );
          messagePayload.GroupTypeID = "2";
          messagePayload.MessageCategoryTypeID = selectedDynamicGroup.GroupFilterTypeID;
          messagePayload.GroupFilterTypeID = selectedDynamicGroup.GroupFilterTypeID;
          messagePayload.GroupFilterTypeData1 = selectedDynamicGroup.FilterData1;
          if (selectedDynamicGroup.FilterData2) {
            messagePayload.GroupFilterTypeData2 = selectedDynamicGroup.FilterData2;
          }
        }
        messagePayload.MessageTypeID = 1; // For SMS, it's 1
        try {
          await Api.ivr.private.schedule(messagePayload);
          this._showSuccessMessage("Message scheduled successfully");
          EventEmitter.dispatch("message-scheduled");
          // this.notification = "Call successfully scheduled";
          // this.snackbar = true;
        } catch (error) {
          this.notification = "Unable to schedule call";
          this.snackbar = true;
        }
      },

      close() {
        this.isPromptVisible = false;
        this._reset();
      },

      _getValidHourRanges() {
        let validHourRange = [[8, 20]];
        if (this.startDate) {
          const selectedDate = moment(this.startDate).format("DD-MM-YYYY");
          const currentDate = moment().format("DD-MM-YYYY");
          if (selectedDate === currentDate) {
            // eslint-disable-next-line no-undef
            // eslint-disable-next-line radix
            const currentHour = parseInt(moment().format("H"));
            if (currentHour > 20) {
              validHourRange = [];
            } else {
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              const currentMinute = parseInt(moment().format("m"));
              if (currentMinute < 45) {
                validHourRange = [[currentHour, 20]];
              } else {
                validHourRange = [[currentHour + 1, 20]];
              }
            }
          }
        }
        return validHourRange;
      },

      onFileChange(e) {
        const allowedFileTypes = ["image/jpeg", "image/gif", "image/png"];
        const uploadedFile = e.target.files[0];
        // Check if file type is valid
        if (allowedFileTypes.indexOf(uploadedFile.type) > -1) {
          // Check if it exceeds the size limit
          const allowedFileSize = process.env.VUE_APP_MMS_ATTACHMENT_SIZE_LIMIT_IN_KB || 4 * 1024;
          if (uploadedFile.size / 1024 <= allowedFileSize) {
            // eslint-disable-next-line prefer-destructuring
            this.file = e.target.files[0];
          } else {
            this.notification = `File size too large, maximum allowed size is ${allowedFileSize /
              1024} MB`;
            this.snackbar = true;
          }
        } else {
          this.notification = "The selected file type is not allowed";
          this.snackbar = true;
        }
      },

      onFileDelete() {
        this.selectedTemplateMediaUrl = "";
        this.file = null;
      },

      async uploadFile() {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          const res = await ApiCalls.uploadMedia(formData);
          return res.data;
        } catch (error) {
          console.log("error :>> ", error);
          return "";
        }
      },

      formatMemory(x) {
        const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        let l = 0;
        let n = parseInt(x, 10) || 0;

        while (n >= 1024 && ++l) {
          // eslint-disable-next-line operator-assignment
          n = n / 1024;
        }
        // include a decimal point and a tenths-place digit if presenting
        // less than ten of KB or greater units
        // eslint-disable-next-line prefer-template
        return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
      },

      _getValidMinuteRanges() {
        let validMinuteRange = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
        if (this.startDate) {
          const selectedDate = moment(this.startDate).format("DD-MM-YYYY");
          const currentDate = moment().format("DD-MM-YYYY");
          if (selectedDate === currentDate) {
            if (this.time) {
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              const currentHour = parseInt(moment().format("H"));
              // eslint-disable-next-line no-undef
              // eslint-disable-next-line radix
              let selectedHour = parseInt(this.time.split(":")[0]);
              const selectedformat = this.time.split(" ")[1];
              // eslint-disable-next-line no-restricted-globals
              if (selectedformat === "pm" && !isNaN(selectedHour)) {
                selectedHour += 12;
              }
              if (selectedHour === currentHour) {
                // eslint-disable-next-line no-undef
                // eslint-disable-next-line radix
                const currentMinute = parseInt(moment().format("m"));
                const allowedMinuteRanges = [15, 30, 45];
                validMinuteRange = [];
                // eslint-disable-next-line no-restricted-syntax
                for (const allowedMinuteRange of allowedMinuteRanges) {
                  if (allowedMinuteRange >= currentMinute) {
                    validMinuteRange.push(allowedMinuteRange);
                  }
                }
              }
            } else {
              validMinuteRange = [];
            }
          }
        }
        return validMinuteRange;
      },

      async _executeFlow(phoneNumbers, isGroupMessage = false) {
        console.log("phoneNumbers :>> ", phoneNumbers);
        const activeClinic = _getPracticeIdFromStore();
        const messagePayload = {
          FlowID: this.selectedTemplate.flowID,
          ToNumbers: "",
          FlowPhoneNumber: "+17088872527",
          FlowParameters: [
            {
              Parameter: "firstname",
              ParameterValue: "John"
            },
            {
              Parameter: "lastname",
              ParameterValue: "Doe"
            },
            {
              Parameter: "practicename",
              ParameterValue: activeClinic.name
            },
            {
              Parameter: "doctor",
              ParameterValue: "Dr. Smith"
            },
            {
              Parameter: "ApptDate",
              ParameterValue: "June 11, 2022"
            },
            {
              Parameter: "message",
              ParameterValue: this.field.content
            }
          ]
        };
        if (isGroupMessage) {
          messagePayload.GroupID = this.selectedGroupId;
          if (this.selectedGroupType === "static") {
            messagePayload.GroupTypeID = "1";
          } else {
            messagePayload.GroupTypeID = "2";
          }
        } else {
          messagePayload.ToPhoneNumbers = phoneNumbers;
        }
        messagePayload.MessageCategoryTypeID = 3;
        if (this.selectedGroupType === "static") {
          messagePayload.GroupTypeID = "1";
        } else {
          const selectedDynamicGroup = this.dynamicGroups.find(
            g => g.GroupID === this.selectedGroupId
          );
          if (selectedDynamicGroup) {
            messagePayload.MessageCategoryTypeID = selectedDynamicGroup.GroupFilterTypeID;
            messagePayload.GroupTypeID = "2";
            messagePayload.GroupFilterTypeID = selectedDynamicGroup.GroupFilterTypeID;
            messagePayload.GroupFilterTypeData1 = selectedDynamicGroup.FilterData1;
            if (selectedDynamicGroup.FilterData2) {
              messagePayload.GroupFilterTypeData2 = selectedDynamicGroup.FilterData2;
            }
          }
        }
        messagePayload.MessageTypeID = 1; // For SMS, it's 1
        try {
          await Api.ivr.private.initiateBulkCall(messagePayload);
          // this.notification = "Test call successfully initiated";
          this.snackbar = true;
          this.$emit("on-success");
          this.close();
        } catch (error) {
          this.notification = "Unable to send email";
          this.snackbar = true;
          this.$emit("on-error", error);
        }
      },

      _isFlowExecutionRequired() {
        if (
          this.selectedTemplate &&
          this.selectedTemplate.flowID &&
          this.selectedTemplate.flowID.length
        ) {
          return true;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
.placeHoldersWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 15px;
  margin-top: 25px;
  margin-bottom: 15px;
  border: 1px solid rgb(58, 58, 58);
  border-radius: 8px;
  position: relative;
  padding-top: 42px;

  .templateTypeSelectorOuterWrapper {
    position: absolute;
    top: 15px;
    right: 15px;

    .templateTypeSelectorInnerWrapper {
      display: flex;
      border: 1px solid #3dbc83;
      border-radius: 60px;
      padding: 4px 4px;
      background: #3dbc83;
      transition: 0.3s !important;

      &:hover {
        background: #21ad6e;
      }

      .tab {
        padding: 2px 8px;
        border-radius: 60px;
        font-size: 8px;
        color: white;
        font-weight: 600;
        cursor: pointer;

        &.selected {
          color: white;
          // padding: 2px 12px;
          font-size: 10px;
          box-shadow: 6px 6px 8px rgba(0, 0, 0, 0.2);
          background: #020202;
          font-weight: 600;
        }
      }
    }
  }
}

.label {
  color: rgb(17, 17, 17);
  font-weight: 600;
  margin-right: 15px;
  width: 150px;
}

.dropdown {
  display: inline-block;
  position: relative;
}

.dd-button {
  display: inline-block;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 4px 80px 4px 60px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
}

.dd-button:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
}

.dd-button:hover {
  background-color: #eeeeee;
}

.dd-input {
  display: none;
}

.dd-menu {
  position: absolute;
  top: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0 0 0 0;
  z-index: 5555555;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  list-style-type: none;
}

.dd-input+.dd-menu {
  display: none;
}

.dd-input:hover+.dd-menu {
  display: block;
}

.dd-menu li {
  width: 180px;
  padding: 0px 20px;
  cursor: pointer;
  white-space: nowrap;
}

.dd-menu li:hover {
  background-color: #f6f6f6;
}

.dd-menu li a {
  display: block;
  margin: -10px -20px;
  padding: 10px 20px;
}

.dd-menu li.divider {
  padding: 0;
  border-bottom: 1px solid #cccccc;
}

.toggleWrapper {
  display: flex;
  align-items: center;

  span {
    font-size: 1.1rem;
    margin-left: 1rem;
  }

  input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
  }

  input[type="checkbox"]:focus {
    outline: 0;
  }

  .toggle {
    height: 16px;
    width: 42px;
    border-radius: 16px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: 2px solid grey;
    background: grey;
    transition: all 0.2s ease;
  }

  .toggle:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
    transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
  }

  .toggle:checked {
    border-color: rgb(0, 182, 91);
    background: rgb(0, 185, 108);
  }

  .toggle:checked:after {
    transform: translatex(20px);
  }
}
</style>
<style lang="scss">
.fileWrapper {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);

  .filePart {
    flex: 7;
    display: flex;
    align-items: center;

    .iconWrapper {
      margin-right: 12px;
      color: rgb(0, 182, 91);

      * {
        color: rgb(0, 182, 91);
      }
    }

    .nameWrapper {
      margin-top: 3px;
      font-size: 0.9rem;
      font-weight: 400;
      line-height: 18px;

      .fileSize {
        font-size: 0.7rem;
        font-weight: 600;
      }
    }
  }

  .actionPart {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .changeBtn {
      background-color: rgb(56, 179, 255);
      padding: 0px 15px;
      cursor: pointer;
      font-weight: 600;
      color: white;

      * {
        font-size: 1.3rem;
        color: white;
        margin-top: -4px;
      }

      border-radius: 50px;
      font-size: 0.8rem;
    }

    .removeBtn {
      cursor: pointer;

      * {
        color: rgb(251, 59, 59);
      }
    }
  }
}

.uploadBtn {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  justify-content: center;
  cursor: pointer;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);

  .iconWrapper {
    margin-right: 12px;
    color: rgb(0, 182, 91);

    * {
      color: rgb(0, 182, 91);
    }
  }

  .labelWrapper {
    color: rgb(0, 182, 91);
    margin-top: 3px;
    font-size: 0.9rem;
    font-weight: 400;
  }

  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.088);
  }
}

.bulktabSwitcher {
  width: 100%;
  display: flex;
  margin-bottom: 1rem;
  margin-top: 1rem;
  justify-content: flex-start;
  align-items: center;

  .tabSwitcherInnerWRapper {
    padding: 5px 8px;
    border: 1px solid #050505;
    border-radius: 25px;
    display: flex;

    .tab {
      padding: 5px 15px;
      font-size: 10px;
      cursor: pointer;
      color: #161616;
      font-weight: 600;

      &.selected {
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
        color: white;
        background-color: #1d1d1d;
        cursor: unset;
        border-radius: 25px;
      }
    }
  }
}

.progressWrapper {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .spinner {
    margin-left: 0rem !important;
  }

  img {
    margin-bottom: 25px;
  }
}

.messageCharCounter {
  width: 100%;
  text-align: right;
}

.messageCharCounterexcedded {
  color: red;
}

.select-dropdown,
.select-dropdown * {
  margin: 0;
  padding: 0;
  position: relative;
  box-sizing: border-box;
}

.select-dropdown {
  position: relative;
  background-color: #e6e6e6;
  border-radius: 4px;
}

.select-dropdown select {
  font-size: 1rem;
  font-weight: normal;
  width: 100%;
  padding: 8px 24px 8px 10px;
  border: none;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.select-dropdown select:active,
.select-dropdown select:focus {
  outline: none;
  box-shadow: none;
}

.select-dropdown:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 8px;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-top: 5px solid #aaa;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}
</style>
